<template>
  <div class="buy-one-get-one-container">
    <div class="buy-one-get-one-content" >
      {{ $t('buy') }} {{this.fromQty}} {{ $t('get') }} {{this.relatedQty}}
    </div>
  </div>
</template>

<script>
export default {
  name: "buy-one-get-one",
  props: [
    'fromQty',
    'relatedQty',
  ],
  data() {
    return {
    }
  }
}
</script>

<style lang="less">
.buy-one-get-one-container {
  position: relative;
  width: 0;
  height: 0;

  .buy-one-get-one-content {
    position: absolute;
    top: 5px;
    left: 0;
    z-index: 99;
    border-radius: 15px;
    font-size: 12px;
    white-space: nowrap;
    padding: 3px 10px;
    //color: #fa6400;
    //border: 2px solid #fa6400;
    background-color: #fa6400;
    color: #FFFFFF;
  }
}

@media only screen and (max-width: 800px) {
  .buy-one-get-one-container {
    width: 100%;

    .buy-one-get-one-content {
      padding: 2px 6px;
      font-size: 9px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/buy-one-get-one/buy-one-get-one.vue